import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http.postData("/pemantauan-ttv-harian", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function update(id, data) {
  const response = await http.putData(`/pemantauan-ttv-harian/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/pemantauan-ttv-harian`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/pemantauan-ttv-harian/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

export default {
  create,
  update,
  getByRegister,
  destroy
};
